module.exports = __webpack_public_path__ + "static/logo-wsc-885fd8582ce258b8dc3ef83e13bc247a.png";